import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { Eyebrow } from "@/components/ui-kit/Kit";
import { MaskLines, Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

export const Principle = () => {
  const { t } = useI18n();
  const title = t("home.principle.title");
  const chapters = t("home.principle.chapters") || [];
  const lines = String(title).split(". ").filter(Boolean).map((l, i, arr) => (i === arr.length - 1 ? l : `${l}.`));

  return (
    <section
      className="relative overflow-hidden bg-navy-deep py-24 text-white grain sm:py-36"
      data-testid="principle-section"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hairline-grid" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 top-1/3 h-[420px] w-[420px] rounded-full bg-grn/10 blur-[120px]"
      />
      <div className="relative container">
        <Reveal>
          <Eyebrow tone="gold">{t("home.principle.eyebrow")}</Eyebrow>
        </Reveal>

        <h2 className="mt-10 max-w-[26ch] font-display text-[clamp(1.9rem,4.6vw,3.6rem)] font-semibold leading-[1.06] tracking-[-0.02em]">
          <MaskLines lines={lines} />
        </h2>

        <Reveal delay={0.2}>
          <p className="mt-12 max-w-2xl border-l border-gold/40 pl-6 text-sm leading-relaxed text-white/60 sm:text-base">
            {t("home.principle.body")}
          </p>
        </Reveal>

        <Stagger className="mt-20 grid gap-10 sm:grid-cols-3">
          {chapters.map((ch) => (
            <StaggerItem key={ch.n}>
              <div className="border-t border-white/15 pt-6" data-testid={`principle-chapter-${ch.n}`}>
                <span className="font-mono text-[11px] tracking-[0.3em] text-gold">CHAPTER {ch.n}</span>
                <h3 className="mt-5 font-display text-xl font-medium">{ch.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-white/55">{ch.body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
